<script>
import { VTextarea } from 'vuetify/lib'
import VuelidateMixin from "@/components/General/Form/Mixin/VuelidateMixin";
export default {
    mixins: [VuelidateMixin],
    extends: VTextarea,
    props: {
        filled: {
            default: true,
            type: Boolean
        },
        hideDetails: {
            default: 'auto',
        },
    },
}
</script>
